import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinnerThird } from "@fortawesome/duotone-regular-svg-icons";
import React from "react";
import { twMerge } from "tailwind-merge";
interface ButtonProps {
  onClick?: (e: Event) => void;
  children: React.ReactNode;
  disabled?: boolean;
  isActive?: boolean;
  loading?: boolean;
  className?: string;
}

const Button: React.FC<
  ButtonProps & React.ButtonHTMLAttributes<HTMLButtonElement>
> = ({
  onClick,
  children,
  disabled = false,
  isActive = false,
  loading = false,
  type = "button",
  className = "",
  ...props
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled || loading}
      data-active={isActive ? "active" : "inactive"}
      type={type}
      className={twMerge(
        "py-2 disabled:opacity-20 relative gap-2 items-center px-2 lg:px-3 flex text-nowrap homepage-text-sm  bg-[var(--button-bg-color)] text-[var(--button-text-color)] hover:bg-[var(--button-hover-bg-color)] hover:text-[var(--button-hover-text-color)] data-[active=active]:bg-[var(--button-active-bg-color)] data-[active=active]:text-[var(--button-active-text-color)]",
        "homepage-button-rounded",
        className
      )}
      {...props}
    >
      {loading && (
        <FontAwesomeIcon
          className="size-5 text-white animate-spin"
          icon={faSpinnerThird}
        />
      )}
      {children}
    </button>
  );
};

export default Button;
